import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("img", {
    class: "width20px vertical-align-middle",
    src: _ctx.image[_ctx.type]
  }, null, 8, ["src"]))
}